// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"fab52db8","990":"a6f8247d"}[chunkId] + ".chunk.js";
};